import { Auth } from "aws-amplify";
import { loader } from "graphql.macro";
import { executeGraphqlMutation, executeGraphqlQuery } from "../../graphql/api";
import { SNACKBAR } from "../../utils/constants";
import { formatPhoneNumber } from "../../utils/utilities";
import { updateDashboardLoader } from "../action-creators/loaderActionCreators";
import snackbarOpen from "../action-creators/snackbarActionCreators";
import { updateAdjusterSchedule, updateOutOfOffice } from "../action-creators/userActionCreator";

const createAdjusterScheduleMutation = loader(
  "../../graphql/mutations/createAdjusterSchedule.graphql"
);

const getAdjusterScheduleQuery = loader(
  "../../graphql/queries/getAdjusterSchedule.graphql"
);
const createOutOfOffice = loader(
  "../../graphql/mutations/createOutofOffice.graphql"
);
const updateOutofOffice = loader(
  "../../graphql/mutations/updateOutofOffice.graphql"
);
const deleteOutOfOffice = loader(
  "../../graphql/mutations/deleteOutofOffice.graphql"
);
const getOutOfOfficeDetails = loader(
  "../../graphql/queries/getOutofOfficeStatus.graphql"
);

export async function doLogin() {
  try {
    await Auth.federatedSignIn({ customProvider: "Auth0" });
  } catch (error) {
    console.error("Authentication failed with Auth0 provider:", error);
  }
}

export async function getUserInfo() {
  return await Auth.currentAuthenticatedUser();
}

export const createOrUpdateAdjusterSchedule = (
  adjusterInput: any,
  callback?: (res: any) => void,
  errorCallback?: (error: any) => void
) => {
  return (dispatch: any) => {
    dispatch(updateDashboardLoader({ isLoading: true }));
    executeGraphqlMutation(createAdjusterScheduleMutation, adjusterInput)
      .then((res: any) => {
        let response = res.data && res.data.createAdjusterSchedule;
        dispatch(updateAdjusterSchedule(response));
        dispatch(updateDashboardLoader({ isLoading: false }));
        callback && callback(res);
      })
      .catch((error) => {
        errorCallback && errorCallback(error);
        console.log(error);
        dispatch(updateDashboardLoader({ isLoading: false }));
        dispatch(
          snackbarOpen({
            open: true,
            message: error.message,
            type: SNACKBAR.ERROR,
          })
        );
      });
  };
};

export const getAdjusterSchedule = (
  adjusterInput: any,
  callback?: (res: any) => void,
  errorCallback?: (error: any) => void
) => {
  return (dispatch: any) => {
    executeGraphqlQuery(getAdjusterScheduleQuery, adjusterInput)
      .then((res: any) => {
        let response =
          res.data &&
          res.data.getAdjusterSchedule &&
          res.data.getAdjusterSchedule[0];

        dispatch(
          updateAdjusterSchedule({
            ...response,
            workPhoneNumber: formatPhoneNumber(response.workPhoneNumber),
          })
        );
        callback && callback(res);
      })
      .catch((error) => {
        errorCallback && errorCallback(error);
        console.log(error);
        dispatch(
          snackbarOpen({
            open: true,
            message: error.message,
            type: SNACKBAR.ERROR,
          })
        );
      });
  };
};

export function createOutOfficeStatus(createOutOfOfficeInput: any, callback?: (response: any) => any, errorCallback?: (response: any) => any) {
  return (dispatch: any, store: any) => {
    let user = store().user;
    dispatch(updateDashboardLoader({ isLoading: true }));
    executeGraphqlMutation(createOutOfOffice, createOutOfOfficeInput)
      .then((res: any) => {
        let status = res.data.createOutOfOfficeStatus;
        dispatch(updateOutOfOffice(status));
        dispatch(updateDashboardLoader({ isLoading: false }));
        callback && callback(status);
      })
      .catch((error: any) => {
        errorCallback && errorCallback(error)
        dispatch(updateDashboardLoader({ isLoading: false }));
        dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
      })
  }
}

export function updateOutOfficeStatus(updateOutOfOfficeInput: any, callback?: (response: any) => any, errorCallback?: (response: any) => any) {
  return (dispatch: any, store: any) => {
    let user = store().user;
    dispatch(updateDashboardLoader({ isLoading: true }));
    executeGraphqlMutation(updateOutofOffice, updateOutOfOfficeInput)
      .then((res: any) => {
        let status = res.data.updateOutOfOfficeStatus;
        dispatch(getOutofOfficeStatus({ adjusterId: user?.email }));
        dispatch(updateDashboardLoader({ isLoading: false }));
        callback && callback(status);
      })
      .catch((error: any) => {
        errorCallback && errorCallback(error)
        dispatch(updateDashboardLoader({ isLoading: false }));
        dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
      })
  }
}

export function deleteOutofOfficeStatus(deleteOutOfOfficeInput: any, callback?: (response: any) => any, errorCallback?: (response: any) => any) {
  return (dispatch: any, store: any) => {
    let user = store().user;
    dispatch(updateDashboardLoader({ isLoading: true }));
    executeGraphqlMutation(deleteOutOfOffice, deleteOutOfOfficeInput)
      .then((res: any) => {
        let status = res.data.createOutOfOfficeStatus;
        dispatch(updateOutOfOffice({
          adjusterId: null,
          endDate: null,
          id: null,
          messageId: null,
          message: null,
          outOfOfficeStatus: null,
          startDate: null
        }));
        dispatch(updateDashboardLoader({ isLoading: false }));
        callback && callback(status);
      })
      .catch((error: any) => {
        errorCallback && errorCallback(error)
        dispatch(updateDashboardLoader({ isLoading: false }));
        dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
      })
  }
}

export function getOutofOfficeStatus(getOutOfOfficeInput: any, callback?: (response: any) => any, errorCallback?: (response: any) => any) {
  return (dispatch: any, store: any) => {
    let user = store().user;
    dispatch(updateDashboardLoader({ isLoading: true }));
    executeGraphqlMutation(getOutOfOfficeDetails, getOutOfOfficeInput)
      .then((res: any) => {
        let response = res.data.getOutOfOfficeStatus;
        dispatch(updateOutOfOffice(response));
        dispatch(updateDashboardLoader({ isLoading: false }));
        callback && callback(response);
      })
      .catch((error: any) => {
        errorCallback && errorCallback(error)
        dispatch(updateDashboardLoader({ isLoading: false }));
        dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
      })
  }
}

